import React from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { AudienceSummaryItemType, ISummaryItem } from '../../../../models';
import { IApplicationState } from '../../../../store';
import { Col3Col9 } from '../../../common';

const HeadlessSection = styled.div`
    padding-top 10px;
    padding-bottom: 60px;
    padding-left: 10px;
    padding-right: 10px;
`;

export const AudienceMenuSummary = (props: { audienceId: number }) => {
	const { surveyAdminSummary } = useSelector((state: IApplicationState) => state.surveyAdmin);

	const items = getAudienceSummaryItems();

	return (
		<HeadlessSection>
			{items?.map((audienceItem: ISummaryItem, audienceIndex: number) => {
				return (
					<Col3Col9 key={audienceIndex} label={audienceItem.displayName} labelSize={'md'} clearHeight={'0'}>
						{audienceItem.value}
					</Col3Col9>
				);
			})}
		</HeadlessSection>
	);

	function getAudienceSummaryItems() {
		const returnItems: ISummaryItem[] = [];
		const allAudiencesItems: [] | undefined = surveyAdminSummary?.audienceSummaryItem?.value;

		const audienceSummaryItems: ISummaryItem[] | undefined = _.find(allAudiencesItems, (summaryItem, index: string) => {
			if (index === props.audienceId.toString()) {
				return true;
			}
		}) as ISummaryItem[] | undefined;

		audienceSummaryItems?.forEach((aItem) => {
			if (aItem.propertyName == AudienceSummaryItemType.SurveyLink) {
				returnItems.push(aItem);
			}
		});
		return returnItems;
	}
};
